<template>
  <div class="sale-change-subscription">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="modal-title">Configurar pagamento</h5>
      <button class="btn btn-sm" @click="$emit('close')">
        <i class="fa fa-close fs-20 text-secondary" />
      </button>
    </div>
    <p class="modal-description mb-5">
      Esta nova data de cobrança será válida para as próximas cobranças ainda
      não agendadas.
    </p>
    <form-group
      v-model="form.day"
      :errors="errors.day"
      id="day"
      placeholder="DATA DE COBRANÇA"
      select
      :options="options"
    />
    <div class="text-center mt-6">
      <button class="btn btn-block btn-primary" @click="reBillet">
        <loading :show="loading">Salvar</loading>
      </button>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import get from "lodash/get";

export default {
  props: {
    item: {
      type: Number,
      required: true
    }
  },
  data() {
    const padStart = n => `${n}`.padStart(2, "0");
    return {
      ...formFields(["day"]),
      options: Array(31)
        .fill(0)
        .map((val, index) => index + 1)
        .map(val => ({ id: padStart(val), name: padStart(val) }))
    };
  },
  methods: {
    reBillet() {
      this.loading = true;
      window.axios
        .post(`/subscriptions/change-next-billing-at/${this.item}`, this.form)
        .then(response => {
          this.$message.success("Pagamento configurado com sucesso");
        })
        .catch(error => {
          this.$message.error(
            get(error, "response.data.message", "Erro ao configurar pagamento")
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.sale-change-subscription {
  position: relative;
  ::v-deep .responsive-select .scroll-content {
    max-height: 270px;
  }
}
</style>
